import { Button as NextUIButton } from '@nextui-org/react';
import React from 'react';
import { AppThemeColorVariant } from '../../../types/theme';
import { THEME_PALETTE } from '../../theme/palette';

/*
  primary -> icona senza sfondo
  secondary -> icona con sfondo
*/

interface IIconButton {
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  backgroundColorVariant?: AppThemeColorVariant | 'none';
  onClick: () => void;
  icon: any;
}

export default function IconButton({
  icon,
  onClick,
  disabled = false,
  backgroundColorVariant = 'tertiary',
  variant,
}: IIconButton) {

  const bgColor = React.useMemo(() => {
    if (backgroundColorVariant === 'none') return 'transparent';
    if (variant === 'primary') return 'transparent';
    return THEME_PALETTE[backgroundColorVariant];
  }, [variant, backgroundColorVariant]);

  return (
    <NextUIButton
    disabled={disabled}
      style={{
        backgroundColor: bgColor,
        opacity:disabled?0.5:1
      }}
      isDisabled={disabled}
      onClick={onClick}
      radius='full'
      isIconOnly>
        {icon}
    </NextUIButton>
  )
}